<div class="splash-container">
    <h1>Welcome to Realfinity Platform</h1>
    <p>We are so excited to see you here! Join us on a 
        <a href="https://support.realfinity.io/hc/en-us/articles/35193980928148-Realfinity-Platform-Walkthrough-for-Pre-Licensed-Agents" target="_blank">
            <strong>walkthrough of the platform</strong></a>
        to get familiar with the features and resources you need to embark on this new journey.</p>
    <a href="https://support.realfinity.io/hc/en-us/articles/35193980928148-Realfinity-Platform-Walkthrough-for-Pre-Licensed-Agents" target="_blank">
        <img style="width: 500px; border-radius: 8px;"
        src="https://cdn.loom.com/sessions/thumbnails/252220f11de04e288678dbd29e6b58b1-77b1c982cab41921-full-play.gif">
    </a>
    <div class="Vert-20"></div>
    <button class="btn btn-primary" (click)="dialogRef.close()">Let's Get Started!</button>
</div>